/* eslint-disable react/prop-types */

import 'react-select/dist/react-select.css';
import { withStyles } from '@material-ui/core/styles';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import CancelIcon from '@material-ui/icons/Cancel';
import Chip from '@material-ui/core/Chip';
import ClearIcon from '@material-ui/icons/Clear';
import FormHelperText from '@material-ui/core/FormHelperText';
import Input from '@material-ui/core/Input';
import MenuItem from '@material-ui/core/MenuItem';
import PropTypes from 'prop-types';
import React from 'react';
import TetheredSelectWrap from './tetheredSelectWrap.component';
import Typography from '@material-ui/core/Typography';

class Option extends React.Component {
  handleClick = (event) => {
    this.props.onSelect(this.props.option, event);
  };

  render() {
    const { children, isFocused, isSelected, onFocus } = this.props;

    //Added via AB#513 - For handling Valero's custom dropdown requirements and behavior.
    let childrenValue = (children.includes("|") === true) ? children.split("|")[1].toString() : children.toString();

    return (
      <MenuItem
        onFocus={onFocus}
        selected={isFocused}
        onClick={this.handleClick}
        component="div"
        style={{
          fontWeight: isSelected ? 500 : 400,
          width: '100%'
        }}
      >
        {childrenValue}
      </MenuItem>
    );
  }
}

const SelectWrapped = (props) => {
  const { classes, required, longerSelect, ...other } = props;


  return (
    <TetheredSelectWrap
      id="render-select"
      style={{ width: longerSelect ? 300 : 200 }}
      optionComponent={Option}
      noResultsText={<Typography>{'No results found'}</Typography>}
      arrowRenderer={(arrowProps) => {
        return arrowProps.isOpen ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />;
      }}
      clearRenderer={() => <ClearIcon />}
      searchable={true}
      valueComponent={(valueProps) => {
        const { value, children, longerSelect, onRemove } = valueProps;

        const onDelete = (event) => {
          event.preventDefault();
          event.stopPropagation();
          onRemove(value);
        };

        if (onRemove) {
          return (
            <Chip
              tabIndex={-1}
              label={children}
              className={classes.chip}
              deleteIcon={<CancelIcon onTouchEnd={onDelete} />}
              onDelete={onDelete}
            />
          );
        }

        return <div className="Select-value" style={{ color: 'black', maxWidth: '80%', width: longerSelect ? 300 : 200 }}>{children}</div>;
      }}
      {...other}
    />
  );
};

const ITEM_HEIGHT = 48;

const styles = (theme) => ({
  root: {
    width: 200,
    margin: '16px 8px 8px 8px',
  },
  longerRoot: {
    width: 300,
    margin: '16px 8px 8px 8px',
  },
  chip: {
    margin: theme.spacing(0.25),
  },
  inputRoot: {
    zIndex: 0,
  },
  input: {
    height: 'auto',
  },
  // We had to use a lot of global selectors in order to style react-select.
  // We are waiting on https://github.com/JedWatson/react-select/issues/1679
  // to provide a better implementation.
  // Also, we had to reset the default style injected by the library.
  '@global': {
    '.Select-control': {
      marginTop: 17,
      display: 'flex',
      alignItems: 'center',
      border: 0,
      width: '100%',
      height: '18px',
      background: 'transparent',
      '&:hover': {
        boxShadow: 'none',
      },
    },
    '.Select-multi-value-wrapper': {
      flexGrow: 1,
      display: 'flex',
      flexWrap: 'wrap',
    },
    '.Select--multi .Select-input': {
      margin: 0,
    },
    '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
      padding: 0,
    },
    '.Select-noresults': {
      padding: theme.spacing(2),
    },
    '.Select-input': {
      display: 'inline-flex !important',
      padding: 0,
      height: 'auto',
    },
    '.Select-input input': {
      background: 'transparent',
      border: 0,
      padding: 0,
      cursor: 'default',
      display: 'inline-block',
      fontFamily: 'inherit',
      fontSize: 'inherit',
      margin: 0,
      outline: 0,
    },
    '.Select-placeholder, .Select--single .Select-value': {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(16),
      padding: 0,
    },
    '.Select-placeholder': {
      opacity: 0.42,
      color: theme.palette.common.black,
      width: '100%'
    },
    '.Select-menu-outer': {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[2],
      position: 'absolute',
      left: 0,
      top: `calc(100% + ${theme.spacing(1)}px)`,
      width: '100%',
      zIndex: 2,
      maxHeight: ITEM_HEIGHT * 4.5,
    },
    '.Select.is-focused:not(.is-open) > .Select-control': {
      boxShadow: 'none',
    },
    '.Select-menu': {
      maxHeight: ITEM_HEIGHT * 4.5,
      overflowY: 'auto',
    },
    '.Select-menu div': {
      boxSizing: 'content-box',
    },
    '.Select-arrow-zone, .Select-clear-zone': {
      color: theme.palette.action.active,
      cursor: 'pointer',
      height: 21,
      width: 21,
      zIndex: 1,
    },
    // Only for screen readers. We can't use display none.
    '.Select-aria-only': {
      position: 'absolute',
      overflow: 'hidden',
      clip: 'rect(0 0 0 0)',
      height: 1,
      width: 1,
      margin: -1,
    },
  },
});

class CustomSelect extends React.Component {

  render() {
    const { classes, options, placeholder, validator, value, onChange, disabled, longerSelect } = this.props;
    let error;

    if (validator) {
      error = validator(value);
    }

    return (
      <div className={longerSelect ? classes.longerRoot : classes.root}>
        <Input
          classes={{ root: classes.inputRoot, input: classes.input }}
          inputComponent={SelectWrapped}
          style={{ width: longerSelect ? 300 : 200 }}
          inputProps={{
            classes,
            required: true,
            value,
            longerSelect,
            onChange,
            placeholder,
            instanceId: 'react-select-single',
            id: 'react-select-single',
            name: 'react-select-single',
            simpleValue: true,
            options,
          }}
          disabled={disabled}
        />
        {error && <FormHelperText htmlFor="render-select-single">{error}</FormHelperText>}
      </div>
    );
  }
}

CustomSelect.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CustomSelect);